import {REACT_APP_KEYCLOAK_CLIENT_ID, REACT_APP_KEYCLOAK_REALM, REACT_APP_KEYCLOAK_URL} from "../config";
import {User} from "oidc-client-ts";
import {jwtDecode} from "jwt-decode";

type AccessTokenDecodedContent = {
  realm_access: {
    roles: string[];
  };
};

export function getUser(): User | null {
  const authority = REACT_APP_KEYCLOAK_URL + "/realms/" + REACT_APP_KEYCLOAK_REALM;
  const oidcStorage = sessionStorage.getItem(`oidc.user:${authority}:${REACT_APP_KEYCLOAK_CLIENT_ID}`);
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}

export const isAuthorized = (role: string): boolean => {
  const user = getUser();
  if (user === null) {
    return false;
  }
  const tokenParsed = jwtDecode<AccessTokenDecodedContent>(user.access_token);
  const realmRoles = tokenParsed?.realm_access?.roles || [];
  return realmRoles.includes(role);
};

export const useIsAuthorizedFolder: boolean = isAuthorized("api-presales");
